module.exports = __webpack_public_path__ + "img/silver.c9b33c54.svg";